import React from 'react';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import {useMyAccount} from '../../../../../../data/hooks/sessionHooks';
import {userHasBio} from '../../../../../../data/filters/users/userHasBio';
import StartNetworkingStep from '../../../StartNetworkingStep/StartNetworkingStep';

/**
 * Renders the step to add a bio to the user profile
 *
 * @return {JSX.Element} The rendered StepAddBio component.
 */
function StepAddBio() {
    const i18n = useI18n(),
        user = useMyAccount(),
        hasBio = userHasBio(user);

    return (
        <StartNetworkingStep href="./bio" done={hasBio} complete={hasBio}>
            {i18n['start.add_bio']}
        </StartNetworkingStep>
    );
}

export default StepAddBio;
